import React, { useContext } from 'react'
import { Field } from '../../../cms/models/__ModelInfo'
import { fi } from '../../../utils/helpers'
import { useFormField } from '../state'
import { InputField } from './components/InputField/InputField'

const NumberRenderer = ({ field }: { field: Field }) => {
	const formField = useFormField(field.uid)

	const onChange = (e) => {
		let input = e.target.value

		if (input && !isNaN(input)) {
			input = Number(e.target.value)
		}

		formField.setValue(input)
	}

	return (
		<>
			<label className={fi(field.flags.required, 'required')}>
				{field.name}
			</label>
			<InputField onChange={onChange} required={true} value={formField.value} />
		</>
	)
}

export default NumberRenderer
